(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _package = __webpack_require__(7);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _VocLogger = __webpack_require__(8);
	
	var _VocLogger2 = _interopRequireDefault(_VocLogger);
	
	var _ModuleLoader = __webpack_require__(9);
	
	var _ModuleLoader2 = _interopRequireDefault(_ModuleLoader);
	
	var _ScriptLoader = __webpack_require__(10);
	
	var _ScriptLoader2 = _interopRequireDefault(_ScriptLoader);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Voonto.ready.then(function (app) {
	
	  var vocLogger = new _VocLogger2.default(app),
	      moduleLoader = new _ModuleLoader2.default(app),
	      scriptLoader = new _ScriptLoader2.default(app),
	      Nibara = window.nibara;
	  //Nibara.nTools.addNibaraMethod('VERSION',pkg.version);
	  Nibara.VERSION = _package2.default.version;
	
	  vocLogger.initialize().then(function () {
	    Logger.debug('nibara version: ' + _package2.default.version);
	
	    moduleLoader.initialize();
	    scriptLoader.initialize();
	
	    Nibara.moduleLoaderUpdate = function ($elm) {
	      if ($elm instanceof jQuery) {
	        moduleLoader.initialize($elm);
	      } else {
	        Logger.warn('Can not initialize moduleLoader. Element is not instance of jQuery.');
	      }
	    };
	  }).catch(function (e) {
	    Logger.error('Main exception:' + e.message);
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

	module.exports = {"name":"abc-nibara-static","version":"1.7.64","description":"Javascript para abc","main":"src/index.js","scripts":{"test":"./node_modules/.bin/webpack && ./node_modules/.bin/mocha-phantomjs dist/spec/index.html --reporter xunit --file test-results.xml","start":"webpack-dev-server","build":"./node_modules/.bin/webpack","build:watch":"./node_modules/.bin/webpack --watch"},"author":"mbiencinto@vocento.com|fgalindo@vocento.com|jvortiz@ces.vocento.com","license":"SEE LICENSE IN LICENSE.md","devDependencies":{"babel-core":"^6.17.0","babel-loader":"^6.2.5","babel-polyfill":"^6.16.0","babel-preset-es2015":"^6.16.0","chai":"^3.5.0","chalk":"^1.1.3","html-webpack-plugin":"^2.24.1","json-loader":"^0.5.4","mocha":"^3.1.0","mocha-loader":"^1.0.0","mocha-phantomjs":"^4.1.0","webpack":"^1.13.3","webpack-shell-plugin":"^0.4.3"}}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VocLogger = function () {
	  function VocLogger(app) {
	    _classCallCheck(this, VocLogger);
	
	    this.app = app;
	    this.libPath = app.lookup('vocento.config.nibara').libPath;
	    if (this.libPath === undefined) {
	      throw 'nibara libPath config is empty';
	    }
	  }
	
	  _createClass(VocLogger, [{
	    key: 'initialize',
	    value: function initialize() {
	      return this.app.load(this.libPath + 'js-logger/logger.min.js').then(function () {
	
	        /** logger init **/
	        Logger.useDefaults();
	        var myHandler = Logger.createDefaultHandler({
	          formatter: function formatter(messages) {
	            messages.unshift('nibara_debug::');
	          }
	        });
	        Logger.setHandler(function (messages, context) {
	          myHandler(messages, context);
	        });
	
	        /** Change level with require_debug param */
	        Logger.setLevel(Logger.WARN);
	        if (VocLogger.getUrlParam('nibara_debug') === '1') {
	          Logger.setLevel(Logger.DEBUG);
	        }
	      });
	    }
	
	    /**
	     * Obtiene el valor de un parametro de la window.location
	     */
	
	  }], [{
	    key: 'getUrlParam',
	    value: function getUrlParam(name) {
	      var hashes = window.location.search.slice(1).split('&');
	      var hash = void 0;
	      for (var i = 0; i < hashes.length; i++) {
	        hash = hashes[i].split('=');
	        if (hash[0] === name) {
	          return hash.length > 1 ? hash[1] : '';
	        }
	      }
	      return null;
	    }
	  }]);
	
	  return VocLogger;
	}();
	
	exports.default = VocLogger;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuleLoader = function () {
	  function ModuleLoader(app) {
	    _classCallCheck(this, ModuleLoader);
	
	    this.app = app;
	    this.path = app.lookup('vocento.config.nibara').path;
	    if (this.path === undefined) {
	      throw 'nibara path config is empty';
	    }
	    this.libPath = app.lookup('vocento.config.nibara').libPath;
	    if (this.libPath === undefined) {
	      throw 'nibara libPath config is empty';
	    }
	  }
	
	  _createClass(ModuleLoader, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      var $elm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      Logger.debug('ModuleLoader: Initialize');
	
	      /**
	       * InView elements
	       */
	      var nibaraInviewElms = [];
	      if ($elm !== null) {
	        nibaraInviewElms = $elm.find('.nibara-element-inview');
	      } else {
	        nibaraInviewElms = Voonto.$('.nibara-element-inview');
	      }
	
	      if (nibaraInviewElms) {
	        this.app.load(this.libPath + 'jquery-inview-tea3/jquery.inview.min.js').then(function () {
	          nibaraInviewElms.each(function (key, elm) {
	            var $elm = Voonto.$(elm);
	            var offset = $elm.data('offset') || 0;
	
	            /** switch mode LIVE (ON) */
	            if ($elm.data('nibara-inview-mode') === 'live') {
	              $elm.on('inview', function (event, isInView, visiblePartX, visiblePartY) {
	
	                /** wakeup only once */
	                if ($elm.data('awakened') !== true) {
	                  _this.callModuleMethod($elm, 'wakeUp');
	                  $elm.data('awakened', true);
	                }
	                /** top view event */
	                if (isInView && visiblePartY === 'top') {
	                  Logger.debug('[inview live] Visible TOP: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'visibleTop');
	                }
	                /** bottom view event */
	                if (isInView && visiblePartY === 'bottom') {
	                  Logger.debug('[inview live] Visible BOTTOM: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'visibleBottom');
	                }
	                /** entire view event */
	                if (isInView && visiblePartY === 'both') {
	                  Logger.debug('[inview live] Visible ENTIRE: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'visibleEntire');
	                }
	                /** top view event */
	                if (!isInView) {
	                  Logger.debug('[inview live] NOT Visible: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'lyingDownModule');
	                }
	              });
	
	              /** switch mode ONE */
	            } else {
	              $elm.one('inview', function (event, isInView) {
	                if (isInView) {
	                  Logger.debug('[inview one] Visible: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'wakeUp');
	                }
	              });
	            }
	          });
	        });
	      }
	
	      /**
	       * NO InView elements
	       */
	      var nibaraElms = [];
	      if ($elm !== null) {
	        nibaraElms = $elm.find('.nibara-element');
	      } else {
	        nibaraElms = Voonto.$('.nibara-element');
	      }
	
	      if (nibaraElms) {
	        nibaraElms.each(function (key, elm) {
	          var $elm = Voonto.$(elm);
	          _this.callModuleMethod($elm, 'wakeUp');
	        });
	      }
	    }
	
	    /**
	     * Call to module and exec method
	     * @param $elm
	     * @param method
	     */
	
	  }, {
	    key: 'callModuleMethod',
	    value: function callModuleMethod($elm, method) {
	      var moduleName = $elm.data('nibara-module');
	      var module = null;
	      if (moduleName) {
	        var elementFilePath = this.path + '/' + moduleName + '-module.js';
	        elementFilePath = window.nibara.nTools.getStaticNode(elementFilePath);
	        this.app.require([elementFilePath], function (module) {
	          if (typeof module[method] === 'function') {
	            module[method]($elm);
	          } else {
	            Logger.warn('Method "' + method + '" not found in module "' + elementFilePath + '"');
	          }
	        });
	      }
	    }
	  }]);
	
	  return ModuleLoader;
	}();
	
	exports.default = ModuleLoader;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScriptLoader = function () {
	  function ScriptLoader(app) {
	    _classCallCheck(this, ScriptLoader);
	
	    this.app = app;
	    this.path = app.lookup('vocento.config.nibara').path;
	    if (this.path === undefined) {
	      throw 'nibara path config is empty';
	    }
	  }
	
	  _createClass(ScriptLoader, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      Logger.debug('ScriptLoader: Initialize');
	
	      var categoriesStr = Voonto.$('body').data('nibara-loader');
	      if (categoriesStr) {
	        categoriesStr.split(" ").forEach(function (category) {
	          if (category.trim().length > 0) {
	            //Evita los espacios blancos grandes o continuos
	            var scriptName = _this.path + ('/' + category + '-script.js');
	            scriptName = window.nibara.nTools.getStaticNode(scriptName);
	            Logger.debug('ScriptLoader: loading script: ' + scriptName);
	            //Logger.debug('ScriptLoader: loading script: ' + category);
	            _this.app.load(scriptName).catch(function (e) {
	              Logger.error(scriptName + ' not found: ' + e.message);
	            });
	          }
	        });
	      }
	      Logger.debug('ScriptLoader End');
	    }
	  }]);
	
	  return ScriptLoader;
	}();
	
	exports.default = ScriptLoader;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	var NibaraInstance = function (global) {
	
	  var nTools = {};
	  var mainWindow = global;
	  global.ajaxQueue = Voonto.$({});
	
	  nTools.getStaticNode = function (url) {
	    if (window.location.href.match('docker') !== null) {
	      return url;
	    }
	    var nodes = {
	      0: "static",
	      1: "static1",
	      2: "static2",
	      3: "static3",
	      4: "static4"
	    };
	    var mod = url.length % 5;
	    if (url.match('static.abc.es')) {
	      url = url.replace('static', nodes[mod]);
	      Logger.info('static host modified: ' + url);
	    }
	    return url;
	  };
	
	  /**
	   * Para Mejorar las Depuraciones y Ver los Valores de las Variables mas Facilmente se agrega el objeto dbDebug
	   * Agrega funciones init, addData(jsonObject), getData() => jsonObject
	   * @type {{init: window.dbDebug.init, addData: window.dbDebug.addData, getData: window.dbDebug.getData}}
	   */
	  nTools.dbDebug = {
	    init: function init() {
	      localStorage.setItem("dbDebug", '');
	      Logger.info('[dbDebug] init: ');
	    },
	    addData: function addData(obj) {
	      var dbData = this.getData();
	      if (dbData != null && dbData.length > 0) {
	        dbData.push(obj);
	      } else {
	        dbData = [obj];
	      }
	      localStorage.setItem("dbDebug", JSON.stringify(dbData));
	      Logger.info('[dbDebug] New data: ', obj);
	      Logger.info('[dbDebug] Save data: ', dbData);
	    },
	    getData: function getData() {
	      var data = localStorage.getItem("dbDebug");
	      //Logger.info('LocalStorage dbDebug get', data);
	      if (data != null && data.length > 0) {
	        data = JSON.parse(data);
	      }
	      return data;
	    }
	  };
	
	  nTools.cleanerUrl = function (url) {
	    var marks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    if (marks) {
	      //clean marcas de tags o tracking
	      url = url.replace(/#\w+/g, '');
	    }
	    if (parameters) {
	      url = url.replace(/\?.*/g, '');
	    }
	    return url;
	  };
	
	  nTools.getUrlParams = function () {
	
	    var params = {};
	    var queryParams = mainWindow.location.search.length > 0 ? mainWindow.location.search.substr(1).split('&') : '';
	    var queryHash = mainWindow.location.hash.length > 0 ? mainWindow.location.hash.substr(1).split('&') : '';
	
	    var queryVars = {};
	    for (var i = 0; i < queryParams.length; i++) {
	      var hash = queryParams[i].split('=');
	
	      if (hash.length > 1) {
	        queryVars[hash[0]] = hash[1];
	      } else {
	        queryVars[hash[0]] = null;
	      }
	    }
	    params.queryParams = queryVars;
	
	    var hashVars = {};
	    for (var _i = 0; _i < queryHash.length; _i++) {
	      var _hash = queryHash[_i].split('=');
	
	      if (_hash.length > 1) {
	        hashVars[_hash[0]] = _hash[1];
	      } else {
	        hashVars[_hash[0]] = null;
	      }
	    }
	    params.queryHash = hashVars;
	
	    return params;
	  };
	
	  nTools.ajaxQueue = function (ajaxOpts) {
	    var jqXHR = void 0,
	        dfd = Voonto.$.Deferred(),
	        promise = dfd.promise();
	
	    // queue our ajax request
	    ajaxQueue.queue(doRequest);
	
	    // add the abort method
	    promise.abort = function (statusText) {
	
	      // proxy abort to the jqXHR if it is active
	      if (jqXHR) {
	        return jqXHR.abort(statusText);
	      }
	
	      // if there wasn't already a jqXHR we need to remove from queue
	      var queue = ajaxQueue.queue(),
	          index = Voonto.$.inArray(doRequest, queue);
	
	      if (index > -1) {
	        queue.splice(index, 1);
	      }
	
	      // and then reject the deferred
	      dfd.rejectWith(ajaxOpts.context || ajaxOpts, [promise, statusText, ""]);
	      return promise;
	    };
	
	    // run the actual query
	    function doRequest(next) {
	      jqXHR = Voonto.$.ajax(ajaxOpts).done(dfd.resolve).fail(dfd.reject).then(next, next);
	    }
	
	    return promise;
	  };
	
	  return {
	    nTools: nTools
	  };
	}(window);
	
	window.nibara = NibaraInstance;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// nibara.js